<template>
  <span class="vertical-line" />
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.vertical-line {
  display: inline-block;

  width: 1px;
  height: 1em;

  background-color: currentColor;

  opacity: 0.5;
}
</style>
